<template>
    <div class="row teams-row mx-0">
        <div class="d-flex flex-column col-md-3 px-0 border-right py-3">
            <div class="team-actions px-2">
                <div class="form-group d-flex justify-content-center align-items-center">
                    <label class="mb-0 mr-2" for="pause">Show Paused Hotels</label>
                    <input id="pause" type="checkbox" v-model="showPaused" />
                </div>
                <div class="input-and-submit-wrapper form-group">
                    <div class="form-icon">
                        <i class="fas fa-search"></i>
                    </div>
                    <input
                        type="text"
                        class="has-icon form-control"
                        name="group-name"
                        id="group-name"
                        v-model="hotelName"
                        placeholder="Search"
                    />
                </div>
                <div class="d-flex filters justify-content-center mb-3">
                    <a
                        href="#"
                        class="px-2"
                        @click.prevent="toggleFilter('trial')"
                        :class="isActiveFilter('trial')"
                    >Trial ({{ statusCounts.trial }})</a>
                    <a
                        href="#"
                        class="px-2"
                        @click.prevent="toggleFilter('subscribed')"
                        :class="isActiveFilter('subscribed')"
                    >Subscribed ({{ statusCounts.subscribed }})</a>
                    <a
                        href="#"
                        class="px-2"
                        @click.prevent="toggleFilter('all')"
                        :class="isActiveFilter('all')"
                    >All ({{ statusCounts.all }})</a>
                    <div class="dropdown">
                        <a
                            href="#"
                            class="px-2 dropdown-toggle"
                            id="dropdownFilters"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            More Filters
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownFilters">
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="setTypeFilter('all-types')"
                                :class="isActiveTypeFilter('all-types')"
                            >All ({{ typeCounts.allTypes }})</a>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="setTypeFilter('cruiseline')"
                                :class="isActiveTypeFilter('cruiseline')"
                            >Cruise Line ({{ typeCounts.cruiseline }})</a>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="setTypeFilter('restaurant')"
                                :class="isActiveTypeFilter('restaurant')"
                            >Restaurant ({{ typeCounts.restaurant }})</a>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="setTypeFilter('hotel')"
                                :class="isActiveTypeFilter('hotel')"
                            >Hotel ({{ typeCounts.hotel }})</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="teams vertical-scroll">
                <div
                    v-for="team in filteredTeams"
                    :key="team.id"
                    @click="selectTeam(team)"
                    class="cursor-pointer px-2 py-2 team d-flex"
                    :class="{ active: activeTeamId == team.id }"
                >
                    <span class="col">{{ team.name }}</span>
                    <div class="badges">
                        <i class="fa fa-pause" v-if="team.current_status == 'NO_IMPORT'"></i>
                        <img
                            src="/assets/img/ch-favicon.png"
                            v-if="team.clickhint_plan"
                            height="15"
                            width="15"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-9 view-team py-3 px-4">
            <div v-if="activeTeamId === null">
                <p class="thin-title text-center">Please select a team</p>
            </div>
            <div v-else>
                <manage-team
                    :partner="partner"
                    @update-all="updateAll"
                    :team="activeTeam"
                    :teams="teams"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ManageTeam from './ManageTeam';
import AdministrationMixin from './AdministrationMixin';

export default {
    props: {
        partner: {
            type: Object,
            default: null,
        },
    },
    components: {
        ManageTeam,
    },
    mixins: [AdministrationMixin],
    data() {
        return {
            teams: null,
            activeTeamId: null,
            hotelName: '',
            currentStatusFilter: 'all',
            currentTypeFilter: 'all-types',
            showPaused: false,
        };
    },
    computed: {
        activeTeam() {
            return this.teams?.find((team) => team.id === this.activeTeamId) || null;
        },
        filteredTeams() {
            if (!this.teams) return [];

            return this.teams.filter(team => {
                if (!this.showPaused && team.current_status === 'NO_IMPORT') return false;

                const matchesStatus = this.currentStatusFilter === 'all' || team.status === this.currentStatusFilter;
                const matchesType = this.currentTypeFilter === 'all-types' || team.type === this.currentTypeFilter;
                const matchesName = team.name.toLowerCase().includes(this.hotelName.toLowerCase());

                return matchesStatus && matchesType && matchesName;
            });
        },
        statusCounts() {
            const counts = {
                all: 0,
                subscribed: 0,
                trial: 0,
            };

            if (!this.teams) return counts;

            this.teams.forEach(team => {
                if (!this.showPaused && team.current_status === 'NO_IMPORT') return;

                const matchesType = this.currentTypeFilter === 'all-types' || team.type === this.currentTypeFilter;
                const matchesName = team.name.toLowerCase().includes(this.hotelName.toLowerCase());

                if (matchesType && matchesName) {
                    counts.all++;
                    if (team.status === 'subscribed') counts.subscribed++;
                    if (team.status === 'trial') counts.trial++;
                }
            });

            return counts;
        },
        typeCounts() {
            const counts = {
                allTypes: 0,
                cruiseline: 0,
                restaurant: 0,
                hotel: 0,
            };

            if (!this.teams) return counts;

            this.teams.forEach(team => {
                if (!this.showPaused && team.current_status === 'NO_IMPORT') return;

                const matchesStatus = this.currentStatusFilter === 'all' || team.status === this.currentStatusFilter;
                const matchesName = team.name.toLowerCase().includes(this.hotelName.toLowerCase());

                if (matchesStatus && matchesName) {
                    counts.allTypes++;
                    if (team.type === 'cruiseline') counts.cruiseline++;
                    if (team.type === 'restaurant') counts.restaurant++;
                    if (team.type === 'hotel') counts.hotel++;
                }
            });

            return counts;
        },
    },
    mounted() {
        this.getTeams();
    },
    methods: {
        getTeams() {
            axios
                .get(this.teamsUrl)
                .then((response) => {
                    this.teams = response.data;
                })
                .catch(() => {
                    swal('Oops!', "We couldn't load the hotels", 'danger');
                });
        },
        toggleFilter(value) {
            this.currentStatusFilter = value;
        },
        setTypeFilter(value) {
            this.currentTypeFilter = value;
        },
        isActiveFilter(value) {
            return this.currentStatusFilter === value
                ? 'border-bottom font-weight-bold text-primary'
                : '';
        },
        isActiveTypeFilter(value) {
            return this.currentTypeFilter === value ? 'font-weight-bold text-primary' : '';
        },
        selectTeam(team) {
            this.activeTeamId = team.id;
        },
        updateAll() {
            this.getTeams();
        },
    },
};
</script>

<style scoped>
.teams-row {
    height: 70vh;
    overflow-y: hidden;
}
.teams-row .col-md-3 {
    height: 100%;
}
.teams-row .col-md-3 .teams {
    max-height: calc(100% - 90px);
    overflow-y: auto;
}
.team {
    font-weight: 600;
    color: #90919e;
}
.team.active {
    color: #00aef1;
    font-weight: 600;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.19);
}
.fa-arrow-right {
    font-size: 10px;
    vertical-align: middle;
}
.view-team {
    overflow-y: auto;
    max-height: 100%;
}
.filters .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>
